import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from "app/globals";

import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
@Injectable()
export class AssessmentsService {

    url: string = `${this._Globals.serviceUrl}AssessmentsService.svc/`;

    constructor(
        private httpClient: HttpClient,
        public _Globals: Globals
    ) { }

    getAssignmentCoachDetails(assignmentId: number) {

        let url = `${this.url}BR8?w7=${assignmentId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json');
            //.set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getAssessment(assessmentId: number) {

        let url = `${this.url}Get360Assessment?assessmentId=${assessmentId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getAssessmentPage(assessmentId: number, pageType, language: string) {

        let cpageType = parseInt(pageType);

        let url = `${this.url}GetAssessmentPage?assessmentId=${assessmentId}&pageType=${cpageType}&language=${language}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }


    getAssessmentPageByUserType(assessmentId: number, pageType, language: string, userType: number) {

        let cpageType = parseInt(pageType);

        let url = `${this.url}GetAssessmentPageByUserType?assessmentId=${assessmentId}&pageType=${cpageType}&language=${language}&userType=${userType}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getAssignmentDetails(assignmentId: number) {

        let url = `${this.url}JB9?p8=${assignmentId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json');
        //.set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getAssessmentsByType(is360: boolean) {

        let url = `${this.url}GetAssessmentsByType?is360=${is360}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public postSave360Assessment(assessmentDto: SaveAssessments360Dto): Observable<any> {
        let url = `${this.url}Save360Assessment`;

        let assessment: any = {
            "Id": parseInt(assessmentDto.id),
            "Name": assessmentDto.name,
            "Niche": 1,
            "MajorVersion": parseInt(assessmentDto.majorVersion),
            "MinorVersion": parseInt(assessmentDto.minorVersion),
            "Sections": assessmentDto.sections,
            "RegularAssessmentId": assessmentDto.regularAssessmentId
        };

        let postSaveAssessments: any = {
            "assessment": assessment
        }

        let body = JSON.stringify(postSaveAssessments);
        console.log('body Post Save Assessments: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public postSaveAssessmentPage(pageObj: PageObjDto): Observable<any> {
        let url = `${this.url}SaveAssessmentPage`;

        let body: any = {
            "page": {
                "AssessmentId": pageObj.AssessmentId,
                "PageType": pageObj.PageType,
                "Language": pageObj.Language,
                "Content": pageObj.Content,
                "UserType": pageObj.UserType
            }
        };

        body = JSON.stringify(body);
        console.log('body saveAssessmentPage: ', body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    getPageContent(assessmentId:number, pageType:number, language: string) {
        let url = `${this.url}GetPageContent?assessmentId=${assessmentId}&pageType=${pageType}&language=${language}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getPageContentByUserType(assessmentId: number, pageType: number, language: string, userType: number, assignmentId:number) {
        let url = `${this.url}GetPageContentByUserType?assessmentId=${assessmentId}&pageType=${pageType}&language=${language}&userType=${userType}&assignmentId=${assignmentId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getAssessmentTypes() {
        let url = `${this.url}GetAssessmentTypes`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getAssignmentDetailsForActivation(assignmentId: number, activationCode: string) {
        let url = `${this.url}YU23?ky9=${assignmentId}&nr4=${activationCode}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json');

        return this.httpClient.get(url, { headers: headers });
    }

    getLanguagesForAssignAssessments(assessmentId: number) {
        let url = `${this.url}GA8?nt1=${assessmentId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getAssessmentLink(assessmentId: number) { //TODO: check use
        let url = `${this.url}RO2?wb=${assessmentId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getAssessmentModlllDates() {
        let url = `${this.url}MR8`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getAssessmentModStats(modIIIDate: string) {
        let url = `${this.url}BR4?xc=${encodeURIComponent(modIIIDate)}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    //AssessmentsServices.svc/LN2?sp={modIIIDate}
    getAssessementModPendings(modIIIDate: string) {
        let url = `${this.url}LN2?sp=${encodeURIComponent(modIIIDate)}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    //AssessmentsServices.svc/KW7?sy={modIIIDate}
    getAssessementModCompleted(modIIIDate: string) {
        let url = `${this.url}KW7?sy=${encodeURIComponent(modIIIDate)}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getAssessmentPricing(assessmentId: number) {

        let url = `${this.url}NWS7?lr3=${assessmentId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public saveAssessmentPricing(assessmentId: number, encryptedPricingData: string): Observable<any> {
        let url = `${this.url}MPE4`;

        let body: any = {
            "jw2": assessmentId,
            "nr5": this._Globals.getUserId(),
            "uy3": encryptedPricingData
        };

        body = JSON.stringify(body);
        console.log('body saveAssessmentPricing: ', body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    getAssessmentMod1Stats(modIDate: string) {
        let url = `${this.url}F59?xc=${encodeURIComponent(modIDate)}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getAssessementMod1Pendings(modIDate: string) {
        let url = `${this.url}S85?sp=${encodeURIComponent(modIDate)}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getAssessementMod1Completed(modIDate: string) {
        let url = `${this.url}X36?sy=${encodeURIComponent(modIDate)}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }
}

interface IPageObjDto {
    AssessmentId: number;
    PageType: number;
    Language: string;
    Content: string;
}

export class PageObjDto implements IPageObjDto {
    AssessmentId: number;
    PageType: number;
    Language: string;
    Content: string;
    UserType: number;
}

export class SaveAssessments360Dto {
    id: any;
    name: string;
    niche: string;
    majorVersion: string;
    minorVersion: string;
    sections: any[];
    regularAssessmentId: number;
}